import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import './utils/permission'
import './styles/dark-theme.css'
import { getLocale, installI18n, syncElementUILocale } from './i18n'

syncElementUILocale(getLocale())
Vue.use(ElementUI)
installI18n(Vue)
Vue.config.productionTip = false
store.dispatch('switchThemeMode', store.state.themeMode)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
